
import typography from "assets/theme/base/typography";
import colors from "assets/theme/base/colors";

// Template Dashboard 2 MUI helper functions
// import pxToRem from "assets/theme/functions/pxToRem";

const { size } = typography;
const { text } = colors;

const dialogContentText = {
  styleOverrides: {
    root: {
      
    },
  },
};

export default dialogContentText;
